import { rejectTimeout } from './timeout.no-deps'

export function raceWithTimeout<T>(timeout: number, action: () => Promise<T>) {
    const timeoutP = rejectTimeout<T>(timeout)
    return Promise.race<T>([timeoutP, action()])
}
